export default "__VITE_ASSET__COFOs0j6__"